import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type AiRecommendationFragment = { id: string, type: Types.RecommendedActionTypeEnum, targetModule: Types.RecommendedActionTargetModuleEnum, status: Types.RecommendedActionStatusEnum, card: { title: string, subTitle: string, reasons: Array<string>, avatar?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, actions?: Array<{ type: Types.RecommendedActionCtaTypeEnum, label: string, identifierId?: string | null, path?: string | null, prefill?: string | null, url?: string | null }> | null } };


export type AiRecommendationFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const AiRecommendationFragmentDoc = /*#__PURE__*/ gql`
    fragment AiRecommendation on RecommendedActionSchema {
  id
  type
  targetModule
  status
  card {
    title
    subTitle
    avatar {
      ...EntityMedia
    }
    reasons
    actions {
      type
      label
      identifierId
      path
      prefill
      url
    }
  }
}
    `;